import { useMemo } from "react";

import { map, uniq } from "lodash";

import { IShift } from "~/routes/api/types";

import { useDeepMemo } from "@/common/hooks/useDeepMemo";

import { ISchedule } from "../schedule/types";

import { ShiftTypeHelpers } from "./helpers";
import { useListScheduleShiftTypeQuery } from "./queries";

export const useLegacyShiftTypesForSchedules = (scheduleIds: ISchedule["id"][]) => {
  const memoizedScheduleIds = useDeepMemo(() => uniq(scheduleIds).sort(), [scheduleIds]);

  const { data: scheduleShiftTypes = [] } = useListScheduleShiftTypeQuery(
    { scheduleIds: memoizedScheduleIds },
    { skip: !memoizedScheduleIds.length },
  );
  const scheduleShiftTypeIds = useDeepMemo(
    () => uniq(map(scheduleShiftTypes, "id")).sort(),
    [scheduleShiftTypes],
  );

  return useMemo(() => {
    // Type casting to unknown first because enum values don't type match even with same values
    return ShiftTypeHelpers.byScheduleIdByShiftTypeKey(scheduleShiftTypes) as unknown as Record<
      ISchedule["id"],
      Record<string, IShift>
    >;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scheduleShiftTypeIds]);
};

export const useLegacyShiftTypesForSchedule = (scheduleId?: ISchedule["id"]) => {
  const legacyShiftTypes = useLegacyShiftTypesForSchedules(scheduleId ? [scheduleId] : []);
  return Object.values(scheduleId ? legacyShiftTypes[scheduleId] || {} : {});
};
